import { styled } from "@vw-marketing/us-components";

export const StyledInformationFormWrapper: any = styled.div`
  width: 100%;
`;

export const StyledInputsContainer: any = styled.div`
  ${({ theme }) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static250};
      width: 100%;

      & [class^='StyledLabelTextWithFloating-'],
      & [class*='StyledLabelTextWithFloating-'] {
        color: ${theme.colors.content.active};
      }
    `;
  }}
`;

export const StyledInformationContainer: any = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.size.static300};
  padding-top: ${({ theme }) => theme.size.static250};
`;

export const StyledPhoneInformationContainer: any = styled.div``;

export const StyledCheckBoxContainer: any = styled.div`
  padding-top: ${({ theme }) => theme.size.static300};
`;

export const StyledSubmitButtonContainer: any = styled.div`
  padding-top: ${({ theme }) => theme.size.static350};
`;